import { connect } from 'react-redux';
import { cartSelector, profileSelector } from '../selector';
import { toggleCart, toggleNav } from '../actions';
import {
  HeaderCartItem,
  HeaderProfileItem,
} from '../components/header/headerItems';
import { NavToggle } from '../components/toggle';

const ConnectedHeaderCartItem = connect(
  state => ({
    ...cartSelector(state),
  }),
  dispatch => ({
    toggleCart: () => dispatch(toggleCart()),
  })
)(HeaderCartItem);

const ConnectedHeaderProfileItem = connect(
  state => ({
    customer_number: profileSelector(state).customer_number,
  }),
  null
)(HeaderProfileItem);

const ConnectedNavToggle = connect(
  null,
  dispatch => ({
    onClick: () => dispatch(toggleNav()),
  })
)(NavToggle);

export {
  ConnectedHeaderCartItem,
  ConnectedHeaderProfileItem,
  ConnectedNavToggle,
};



// WEBPACK FOOTER //
// ./src/containers/header.js